module.exports = __webpack_public_path__ + "img/email_verified.815cbb5b.svg";